import { c as _c } from "react/compiler-runtime";
import { CircularProgress, CloudIcon, IconButton } from "@flat-ui";
import { Box, Stack } from "@mui-wrapper";
import { forwardRef } from "react";
/** Renders the button to open the progress overview menu that can show the progress of the file upload */
export const ProgressOverviewButton = forwardRef((t0, ref) => {
  const $ = _c(15);
  let isLoading;
  let rest;
  if ($[0] !== t0) {
    ({
      isLoading,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = isLoading;
    $[2] = rest;
  } else {
    isLoading = $[1];
    rest = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      width: "1em",
      height: "1em",
      transform: "scale(1.25)",
      alignItems: "center",
      justifyContent: "center"
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = isLoading ? "indeterminate" : "determinate";
  const t3 = rest.disabled ? 0 : undefined;
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <CircularProgress variant={t2} value={t3} size="100%" />;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      position: "absolute",
      inset: 0,
      display: "flex"
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Box sx={t5}><CloudIcon sx={{
        width: "100%",
        height: "100%",
        p: "10%"
      }} /></Box>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t4) {
    t7 = <Stack sx={t1} data-testid="progress-overview-button">{t4}{t6}</Stack>;
    $[9] = t4;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== ref || $[12] !== rest || $[13] !== t7) {
    t8 = <IconButton ref={ref} {...rest}>{t7}</IconButton>;
    $[11] = ref;
    $[12] = rest;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
});